// import React, { useEffect, useState } from 'react';
// import '../assets/Banking/VerifyAccount.css'; // Link to your custom CSS
// import axios from 'axios';

// const VerifyAccount = () => {
//   // State to hold form inputs
//   const [customerId, setCustomerId] = useState('1');
//   const [accountType, setAccountType] = useState('');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [referenceNumber, setReferenceNumber] = useState('');
//   const [Loading,setLoading]=useState(false);
//   const [Data,setData]=useState({});

//   // State to hold table data
//   const [tableData, setTableData] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   // Simulating data fetching based on customerId
//   const fetchData = (customerId) => {
//     // Replace this with an actual API call to fetch data based on the customerId
//     const dummyData = [
//       {
//         sn: 1,
//         action: 'Verify',
//         cusName: 'John Doe',
//         cusId: customerId,
//         guardianName: 'Jane Doe',
//         schemeName: 'Fixed Deposit',
//         depositAmount: '$10,000',
//         kycStatus: 'Verified',
//         referenceNumber: '123456',
//         requestedBy: 'Admin',
//         requestedDate: '2025-04-18'
//       },
//       {
//         sn: 2,
//         action: 'Verify',
//         cusName: 'Alice Smith',
//         cusId: customerId,
//         guardianName: 'Bob Smith',
//         schemeName: 'Savings Account',
//         depositAmount: '$5,000',
//         kycStatus: 'Pending',
//         referenceNumber: '789012',
//         requestedBy: 'Admin',
//         requestedDate: '2025-04-17'
//       }
//     ];
//     setTableData(dummyData);
//   };
  

//     useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);


//   // Fetch Accounts
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = profile.superAdminId || 14;
//       const branchId = localStorage.getItem("userId") || 56;

//       const res = await axios.get("https://narrowitsolution.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           branchId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           search: searchQuery || undefined,
//         },
//       });

//       console.log("deposit list:",res)
//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//         setTotalPages(res.data.totalPages || 1);
//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAccounts();
//   }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary]);
//   // Function to handle "Verify" action
//   const handleVerify = (index) => {
//     const updatedData = [...tableData];
//     updatedData[index].action = 'Verified'; // Change "Verify" to "Verified"
//     setTableData(updatedData);
//   };
//   console.log(tableData);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (customerId) {
//       setIsLoading(true);
//       fetchData(customerId); // Fetch data when the form is submitted
//       setIsLoading(false);
//     }
//   };

//   const fetchSavingAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = localStorage.getItem("superAdminId") || 14;
//       const branchId = localStorage.getItem("branchId") || 8;

//       const res = await axios.get("https://narrowitsolution.in/api/get-all-saving-account", {
//         params: { superAdminId, branchId },
//       });

//       console.log("🔵 Saving Accounts API Response:", res.data);

//       if (res.data.success && Array.isArray(res.data.data)) {
//         setData(res.data.data);
//       } else {
//         setData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching saving accounts:", err);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSavingAccounts();
//   }, []);

//   return (
//     <div className="VerifyAccount-wrapper">
//       <section className="VerifyAccount-account-filter-section">
//         <h2 className="VerifyAccount-section-title">Account Filter</h2>
//         <p className="VerifyAccount-section-subtitle">Use filter to see more precise report</p>
//         <form className="VerifyAccount-account-filter-form" onSubmit={handleSubmit}>
//           <div className="VerifyAccount-form-group">
//             <label htmlFor="accountType">Choose Account Type</label>
//             <select
//               id="accountType"
//               name="accountType"
//               value={accountType}
//               onChange={(e) => setAccountType(e.target.value)}
//             >
//               <option selected disabled>Select Account Type</option>
//               <option value="Deposit">Fixed Deposit</option>
//               <option value="savings">Savings Account</option>
//               {/* <option value="current">Current Account</option> */}
//             </select>
//           </div>

//           <div className="VerifyAccount-form-group">
//             <label htmlFor="fromDate">From Date</label>
//             <div className="VerifyAccount-input-with-icon">
//               <input
//                 type="date"
//                 id="fromDate"
//                 name="fromDate"
//                 placeholder="dd-mm-yyyy"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//               />
              
//             </div>
//           </div>

//           <div className="VerifyAccount-form-group">
//             <label htmlFor="toDate">To Date</label>
//             <div className="VerifyAccount-input-with-icon">
//               <input
//                 type="date"
//                 id="toDate"
//                 name="toDate"
//                 placeholder="dd-mm-yyyy"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//               />
              
//             </div>
//           </div>

//           <div className="VerifyAccount-form-group VerifyAccount-align-bottom">
//             <button type="submit" className="VerifyAccount-submit-btn">
//               {isLoading ? 'Loading...' : 'SUBMIT'}
//             </button>
//           </div>
//         </form>
//       </section>

//       <section className="VerifyAccount-verify-account-section">
//         <h2 className="VerifyAccount-section-title">Verify Account</h2>

//         <div className="VerifyAccount-button-row">
//           <button className="VerifyAccount-btn VerifyAccount-csv-btn"><i className="fas fa-file-csv"></i> CSV</button>
//           <button className="VerifyAccount-btn VerifyAccount-excel-btn"><i className="fas fa-file-excel"></i> Excel</button>
//           <button className="VerifyAccount-btn VerifyAccount-print-btn"><i className="fas fa-print"></i> Print</button>

//           <div className="VerifyAccount-entry-control">
//             <span>Show</span>
//             <select aria-label="Show entries">
//               <option>10</option>
//             </select>
//             <span>entries</span>
//           </div>

//           <div className="VerifyAccount-VerifyAccount-search-input">
//             <label htmlFor="searchTableAccount" className="VerifyAccount-VerifyAccount-sr-only">Search</label>
//             <input
//               type="search"
//               id="searchTableAccount"
//               placeholder="Search"
//               className="VerifyAccount-VerifyAccount-search-field"
//             />
//           </div>
//         </div>

//         <div className="VerifyAccount-table-container">
//           <table className="VerifyAccount-account-table">
//             <thead>
//               <tr>
//                 <th>SN <i className="fas fa-sort-up"></i></th>
//                 <th>ACTION</th>
//                 <th>CUS NAME</th>
//                 <th>CUS ID</th>
//                 <th>GUARDIAN NAME</th>
//                 <th>SCHEME NAME</th>
//                 <th>DEPOSIT AMOUNT</th>
//                 <th>KYC STATUS</th>
//                 <th>REFERENCE NUMBER</th>
//                 <th>REQUESTED BY</th>
//                 <th>REQUESTED DATE</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData.length > 0 ? (
//                 tableData.map((row, index) => (
//                   <tr key={index}>
//                     <td>{row.sn}</td>
//                     <td>
//                       {row.action === 'Verify' ? (
//                         <button 
//                           onClick={() => handleVerify(index)} 
//                           className="VerifyAccount-verify-btn"
//                         >
//                           Verify
//                         </button>
//                       ) : (
//                         <span>{row.action}</span>
//                       )}
//                     </td>
//                     <td>{row.cusName}</td>
//                     <td>{row.cusId}</td>
//                     <td>{row.guardianName}</td>
//                     <td>{row.schemeName}</td>
//                     <td>{row.depositAmount}</td>
//                     <td>{row.kycStatus}</td>
//                     <td>{row.referenceNumber}</td>
//                     <td>{row.requestedBy}</td>
//                     <td>{row.requestedDate}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="11" className="VerifyAccount-no-data">No data available in table</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div className="VerifyAccount-pagination-footer">
//           <div className="VerifyAccount-pagination-text">Showing {tableData.length} entries</div>
//           <div className="VerifyAccount-pagination-controls">
//             <button disabled>Previous</button>
//             <button disabled>Next</button>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default VerifyAccount;


import React, { useEffect, useState } from "react";
import "../assets/Banking/VerifyAccount.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const VerifyAccount = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  // Form state
  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Table & pagination state
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRow,setSelectedRow]=useState(null);
  const [isChecked,setIsChecked]=useState(false);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(()=>{
      const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };
    fetchCompany();
  },[profile?.superAdminId])

 const fetchAccounts = async (page = 1) => {
  if (!accountType) return;

  try {
    setLoading(true);
    const superAdminId = profile?.superAdminId ;
    const branchId=profile.branchId;
    const createdBy=localStorage.getItem("userId")
    // 🔹 RD or DD Deposit
    if (accountType === "RD" || accountType === "DD") {
      const res = await axios.get(
        "https://narrowitsolution.in/api/deposit/list",
        {
          params: {
            superAdminId,
            branchId:localStorage.getItem("userId"),
            page,
            limit: rowsPerPage,
            accountType: accountType, // 👈 This sends RD or DD
          },
        }
      );

      if (res.data.success) {
        setTableData(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setTableData([]);
        setTotalPages(1);
      }
    }

    // 🔹 Savings
    else if (accountType === "savings") {
      const res = await axios.get(
        "https://narrowitsolution.in/api/get-all-saving-account",
        {
          params: { superAdminId, branchId,createdBy },
        }
      );

      if (res.data.accounts) {
        setTableData(res.data.accounts || []);
        setTotalPages(1);
      } else {
        setTableData([]);
        setTotalPages(1);
      }
    }
  } catch (err) {
    console.error("Error fetching accounts:", err);
    setTableData([]);
    setTotalPages(1);
  } finally {
    setLoading(false);
  }
};

const handleApprove = async (row) => {
  if(!isChecked)
     {
      toast.error("Check Have you verified every consent.");
      alert("Check Have you verified every consent.");
      return ;
     }
  const isConfirmed = window.confirm(
    "Are you sure you want to approve this account?"
  );

  if (!isConfirmed) return;   // ❌ If user clicks No, stop here

  try {
    const adminId = profile?.superAdminId;

    if (accountType === "savings") {
      // 🔹 Savings Approve
      await axios.put(
        `https://narrowitsolution.in/api/create-saving-account/approve/${row.id}`,
        { approvedBy: adminId }
      );
    } else {
      // 🔹 RD & DD Approve
      await axios.post(
        "https://narrowitsolution.in/api/deposit-account/approve",
        {
          accountId: row.id,
          approvedBy: adminId,
          remarks: `Approved from ${accountType} report`,
        }
      );
    }

    alert("Account approved successfully ✅");
    setSelectedRow(null);
    setIsChecked(false);
    // 🔥 Refresh table after approve
    fetchAccounts(currentPage);

  } catch (error) {
    console.error("Approve Error:", error);
    alert("Something went wrong while approving.");
  }
};


const handleReject = async (row) => {
 
   if(!isChecked)
     {
      toast.error("Check Have you verified every consent.");
      alert("Check Have you verified every consent.")
      return ;
     }
  // ✅ Step 1: Confirmation
  const isConfirmed = window.confirm(
    "Are you sure you want to reject this account?"
  );

  if (!isConfirmed) return;   // ❌ Stop if user clicks Cancel

  // ✅ Step 2: Ask Reason
  const reason = window.prompt("Enter rejection reason:");

  if (!reason || reason.trim() === "") {
    alert("Rejection reason is required.");
    return;
  }

  try {
    const adminId = profile?.superAdminId;

    if (accountType === "savings") {
      // 🔹 Savings Reject
      await axios.put(
        `https://narrowitsolution.in/api/create-saving-account/reject/${row.id}`,
        {
          rejectedBy: adminId,
          rejectReason: reason,
        }
      );
    } else {
      // 🔹 RD & DD Reject
      await axios.post(
        "https://narrowitsolution.in/api/deposit-account/reject",
        {
          accountId: row.id,
          rejectedBy: adminId,
          rejectReason: reason,
        }
      );
    }

    alert("Account rejected successfully ❌");
    setSelectedRow(null);
    setIsChecked(false);

    // 🔥 Refresh table
    fetchAccounts(currentPage);

  } catch (error) {
    console.error("Reject Error:", error);
    alert("Something went wrong while rejecting.");
  }
};


  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchAccounts(1);
  };

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      fetchAccounts(newPage);
    }
    if (direction === "next" && currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      fetchAccounts(newPage);
    }
  };


//  const filteredData = tableData.filter(td =>
//   td.status?.toLowerCase() === "pending"
//  );

    const filteredData = tableData.filter((td) => {
      const isPending = td.status?.toLowerCase() === "pending";

      if (!isPending) return false;

      if (!td.createdAt) return false;

      const requestDate = new Date(td.createdAt);

      // If no date filter selected → show all pending
      if (!fromDate && !toDate) return true;

      const from = fromDate ? new Date(fromDate) : null;
      const to = toDate ? new Date(toDate) : null;

      // Set end date time to 23:59:59 so full day included
      if (to) {
        to.setHours(23, 59, 59, 999);
      }

      if (from && requestDate < from) return false;
      if (to && requestDate > to) return false;

      return true;
    });


//  console.log(filteredData);

    const handleDownloadCSV = () => {
    if (filteredData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const today = new Date().toLocaleDateString("en-GB");

    const headerSection = [
      company?.name || "Company Name",
      company?.address || "",
      `Email: ${company?.email || ""}`,
      `Contact: ${company?.contact || ""}`,
      "",
      `Account Type: ${accountType}`,
      `From Date: ${fromDate || "-"}`,
      `To Date: ${toDate || "-"}`,
      `Export Date: ${today}`,
      "",
    ];

    const tableHeaders = [
      "SN",
      "Customer Name",
      "Customer ID",
      "Guardian Name",
      "Scheme Name",
      "Deposit Amount",
      "Reference Number",
      "Requested Date",
    ];

    const rows = filteredData.map((row, index) => [
      index + 1,
      row.customerName || row.cusName || "--",
      row.customerId || row.cusId || "--",
      row.guardianName || "N/A",
      row.schemeName || row.accountType || "--",
      row.principalAmount || row.openingBalance || "0",
      row.referenceNumber || row.referralId || "N/A",
      row.createdAt
        ? new Date(row.createdAt).toLocaleDateString("en-GB")
        : "--",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [
        ...headerSection,
        tableHeaders.join(","),
        ...rows.map((r) => r.join(",")),
      ].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.href = encodedUri;
    link.download = "Verify_Account_Report.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleDownloadExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const today = new Date().toLocaleDateString("en-GB");

    const exportData = filteredData.map((row, index) => ({
      SN: index + 1,
      "Customer Name": row.customerName || row.cusName || "--",
      "Customer ID": row.customerId || row.cusId || "--",
      "Guardian Name": row.guardianName || "N/A",
      "Scheme Name": row.schemeName || row.accountType || "--",
      "Deposit Amount": row.principalAmount || row.openingBalance || "0",
      "Reference Number": row.referenceNumber || row.referralId || "N/A",
      "Requested Date": row.createdAt
        ? new Date(row.createdAt).toLocaleDateString("en-GB")
        : "--",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData, { origin: "A8" });

    // Add company header rows
    XLSX.utils.sheet_add_aoa(worksheet, [
      [company?.name || "Company Name"],
      [company?.address || ""],
      [`Email: ${company?.email || ""}`],
      [`Contact: ${company?.contact || ""}`],
      [],
      [`Account Type: ${accountType}`],
      [`From: ${fromDate || "-"}   To: ${toDate || "-"}   Export Date: ${today}`],
    ]);

    // Auto column width
    const colWidths = [
      { wch: 5 },
      { wch: 20 },
      { wch: 18 },
      { wch: 20 },
      { wch: 18 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
    ];
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Verify Account Report");

    XLSX.writeFile(workbook, "Verify_Account_Report.xlsx");
  };


  const handlePrint = () => {
    const table = document.querySelector(".VerifyAccount-account-table");
    if (!table) return;

    const clonedTable = table.cloneNode(true);

    // Remove 2nd column (Verify column)
    const rows = clonedTable.querySelectorAll("tr");
    rows.forEach((row) => {
      if (row.children.length > 1) {
        row.deleteCell(1);
      }
    });

    const today = new Date().toLocaleDateString("en-GB");

    const newWindow = window.open("", "", "width=1200,height=800");

    newWindow.document.write(`
      <html>
        <head>
          <title>Account Report</title>
          <style>
            @page {
              size: landscape;
              margin: 12mm;
            }

            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }


            body {
              font-family: 'Segoe UI', Arial, sans-serif;
              font-size: 12px;
              color: #222;
            }

            .header-container {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 2px solid #1e3a8a;
              padding-bottom: 12px;
              margin-bottom: 20px;
              padding-inline:30px;
            }

            .logo img {
              max-height: 70px;
              border-radius: 8px;
            }

            .company-details {
              text-align: left;
            }

            .company-details h2 {
              margin: 0;
              font-size: 20px;
              color: #1e3a8a;
            }

            .company-details p {
              margin: 2px 0;
              font-size: 12px;
            }

            .report-title {
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 15px;
              color: #111;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 11px;
            }

            th {
              background-color: #1e3a8a;
              color: white;
              padding: 8px;
              text-align: left;
              white-space: nowrap;
            }

            td {
              padding: 6px;
              border: 1px solid #ccc;
              white-space: nowrap;
            }

            tr:nth-child(even) {
              background-color: #f8f9fa;
            }

            .footer {
              margin-top: 25px;
              font-size: 11px;
              text-align: right;
              color: #555;
            }

          </style>
        </head>

        <body>

          <div class="header-container">
            <div class="logo">
              ${company?.logoUrl ? `<img src="${company.logoUrl}" />` : ""}
            </div>

            <div class="company-details">
              <h2>${company?.name || ""}</h2>
              <p>${company?.address || ""}</p>
              <p><strong>Email:</strong> ${company?.email || ""}</p>
              <p><strong>Contact:</strong>  ${company?.contact || ""}</p>
            </div>
          </div>

          <div class="report-title">
          ${accountType} Account Report
          </div>

          ${clonedTable.outerHTML}

          <div class="footer">
            Generated on: ${today}
          </div>

        </body>
      </html>
    `);

    newWindow.document.close();
    newWindow.focus();

    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  return (
    <div className="VerifyAccount-wrapper">
      {/* 🔹 Filter Section */}
      <section className="VerifyAccount-account-filter-section">
        <h2 className="VerifyAccount-section-title special-color">Account Filter</h2>
        <p className="VerifyAccount-section-subtitle">
          Use filter to see more precise report
        </p>

        <form
          className="VerifyAccount-account-filter-form"
          onSubmit={handleSubmit}
        >
          <div className="VerifyAccount-form-group">
            <label htmlFor="accountType">Choose Account Type</label>
            <select
              id="accountType"
              name="accountType"
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              required
            >
              <option value="" disabled>
                Select Account Type
              </option>
              <option value="RD">RD Account (RD)</option>
              <option value="DD">DD Account (DD)</option>
              <option value="savings">Savings Account</option>
            </select>
          </div>

          <div className="VerifyAccount-form-group">
            <label htmlFor="fromDate">From Date</label>
            <div className="VerifyAccount-input-with-icon">
              <input
                type="date"
                id="fromDate"
                name="fromDate"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
          </div>

          <div className="VerifyAccount-form-group">
            <label htmlFor="toDate">To Date</label>
            <div className="VerifyAccount-input-with-icon">
              <input
                type="date"
                id="toDate"
                name="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <div className="VerifyAccount-form-group VerifyAccount-align-bottom">
            <button type="submit" className="VerifyAccount-submit-btn">
              {loading ? "Loading..." : "SUBMIT"}
            </button>
          </div>
        </form>
      </section>

      {/* 🔹 Table Section */}
      <section className="VerifyAccount-verify-account-section">
        <h2 className="VerifyAccount-section-title">Verify Account</h2>

        <div className="VerifyAccount-button-row">
          {/* <button className="VerifyAccount-btn VerifyAccount-csv-btn">
            <i className="fas fa-file-csv"></i> CSV
          </button>
          <button className="VerifyAccount-btn VerifyAccount-excel-btn">
            <i className="fas fa-file-excel"></i> Excel
          </button>
          <button className="VerifyAccount-btn VerifyAccount-print-btn">
            <i className="fas fa-print"></i> Print
          </button> */}

          <button
              className="VerifyAccount-btn VerifyAccount-csv-btn"
              onClick={handleDownloadCSV}
            >
              <i className="fas fa-file-csv"></i> CSV
            </button>

            <button
              className="VerifyAccount-btn VerifyAccount-excel-btn"
              onClick={handleDownloadExcel}
            >
              <i className="fas fa-file-excel"></i> Excel
            </button>

            <button
              className="VerifyAccount-btn VerifyAccount-print-btn"
              onClick={handlePrint}
            >
              <i className="fas fa-print"></i> Print
            </button>


          <div className="VerifyAccount-entry-control">
            <span>Show</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
                fetchAccounts(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <span>entries</span>
          </div>
        </div>

        <div className="VerifyAccount-table-container">
          <table className="VerifyAccount-account-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>ACTION</th>
                <th>CUS NAME</th>
                <th>CUS ID</th>
                <th>GUARDIAN NAME</th>
                <th>SCHEME NAME</th>
                <th>DEPOSIT AMOUNT</th>
                {/* <th>STATUS</th> */}
                <th>REFERENCE NUMBER</th>
                {/* <th>REQUESTED BY</th> */}
                <th>REQUESTED DATE</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12" className="VerifyAccount-no-data">
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>
                        <button
                          onClick={() => setSelectedRow(row)}
                          className="VerifyAccount-verify-btn"
                        >
                          Verify
                        </button>
                    </td>
                    <td>{row.customerName || row.cusName || "--"}</td>
                    <td>{row.customerId || row.cusId || "--"}</td>
                    <td>{row.guardianName || "N/A"}</td>
                    <td>{row.schemeName || row.accountType || "--"}</td>
                    <td>{row.principalAmount || row.openingBalance || "0"}</td>
                    {/* <td>{row.status || "--"}</td> */}
                    <td>{row.referenceNumber || row.referralId || "N/A"}</td>
                    {/* <td>{row.requestedBy || "NA"}</td> */}
                    <td>
                      {row.createdAt
                        ? new Date(row.createdAt).toLocaleDateString("en-GB")
                        : "--"}
                    </td>
                    {/* <td className="VerifyAccount-action-buttons">
                      <button
                        onClick={() => handleApprove(row)}
                        className="VerifyAccount-approve-btn"
                      >
                        Approve
                      </button>

                      {accountType=="savings"?<button
                        onClick={() => handleReject(row)}
                        className="VerifyAccount-reject-btn"
                      >
                        Reject
                      </button>:""}
                    </td> */}
                    {/* <td><button onClick={()=>setSelectedRow(row)}>Verify</button></td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="VerifyAccount-no-data">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 🔹 Pagination */}
        <div className="VerifyAccount-pagination-footer">
          <div className="VerifyAccount-pagination-text">
            Page {currentPage} of {totalPages}
          </div>
          <div className="VerifyAccount-pagination-controls">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange("prev")}
            >
              Previous
            </button>
            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange("next")}
            >
              Next
            </button>
          </div>
        </div>



          {/* Modal Popup */}
          {selectedRow && (
            <div className="verify-demo-modal-overlay" onClick={() => {setSelectedRow(null);setIsChecked(false)}}>
              <div
                className="verify-demo-modal-content"
                onClick={(e) => e.stopPropagation()}   // prevent close when clicking inside
              >
                <div className="verify-demo-modal-header">
                  <h3>Account Details</h3>
                  <button
                    className="verify-demo-modal-close"
                    onClick={() => {setSelectedRow(null);setIsChecked(false)}}
                  >
                    ✖
                  </button>
                </div>

                <div className="verify-demo-modal-body">
                    <table className="Demopdf-style-table">
                      <tbody>
                        <tr className="verify-demo-special-row">
                          <td><strong>DETAILS</strong></td>
                          <td><strong>VALUE</strong></td>
                        </tr>
                        <tr>
                          <td><strong>Customer ID</strong></td>
                          <td>{selectedRow?.customerId || selectedRow?.cusId || "--"}</td>
                        </tr>

                        <tr>
                          <td><strong>Customer Name</strong></td>
                          <td>{selectedRow?.customerName || selectedRow?.cusName || "--"}</td>
                        </tr>

                        <tr>
                          <td><strong>Scheme Name</strong></td>
                          <td>{selectedRow?.schemeName || selectedRow?.accountType || "--"}</td>
                        </tr>

                        <tr>
                          <td><strong>Initial Deposit Amount</strong></td>
                          <td>{selectedRow?.principalAmount||selectedRow?.openingBalance || "--"}</td>
                        </tr>

                        <tr>
                          <td><strong>Request Date</strong></td>
                          <td>
                            {selectedRow?.createdAt
                              ? new Date(selectedRow.createdAt).toLocaleString("en-GB")
                              : "--"}
                          </td>
                          {/* <td>{selectedRow.createdAt ? 
                               new Date(selectedRow.createdAt).toLocaleDateString("en-GB") 
                               : "--"}
                          </td> */}
                        </tr>

                        {/* Verify Account Header */}
                        <tr>
                          <td colSpan={2} style={{ textAlign: "center", fontWeight: "bold", padding: "12px" }}>
                            Verify Account
                          </td>
                        </tr>

                        {/* Action Date & Remarks Header */}
                        <tr>
                          <td style={{ textAlign: "center", fontWeight: "600" }}>
                            Action Date
                          </td>
                          <td style={{ textAlign: "center", fontWeight: "600" }}>
                            Action Remarks
                          </td>
                        </tr>

                        {/* Action Date & Remarks Input */}
                        <tr>
                          <td style={{ textAlign: "center", padding: "15px" }}>
                            <input
                              type="date"
                              name="actionDate"
                              style={{ padding: "8px", width: "80%" }}
                            />
                          </td>

                          <td style={{ textAlign: "center", padding: "15px" }}>
                            <input
                              type="text"
                              placeholder="Enter Approval Remarks"
                              style={{ padding: "8px", width: "80%" }}
                            />
                          </td>
                        </tr>

                        {/* Create VAN Account */}
                        <tr>
                          <td><strong>Create VAN Account?</strong></td>
                          <td  style={{textAlign:"left"}}>
                            <label>
                              <input type="radio" name="van" value="yes" /> Yes
                            </label>
                            &nbsp;&nbsp;
                            <label>
                              <input type="radio" name="van" value="no" /> No
                            </label>
                          </td>
                        </tr>

                        {/* Consent Verification */}
                        <tr>
                          <td><strong>Have you verified every consent?</strong></td>
                          <td  style={{textAlign:"left"}}>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => setIsChecked(prev => !prev)}
                            />
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>


                <div className="VerifyAccount-action-buttons">
                      <button
                        onClick={() => handleApprove(selectedRow)}
                        className="VerifyAccount-approve-btn"
                      >
                        Approve
                      </button>

                      {accountType=="savings"?<button
                        onClick={() => handleReject(selectedRow)}
                        className="VerifyAccount-reject-btn"
                      >
                        Reject
                      </button>:""}
                  </div>
              </div>
            </div>
          )}


      </section>
    </div>
  );
};

export default VerifyAccount;

